/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { fork } from 'redux-saga/effects';
import ActionConstants from '../constants';
import { takeLatestUntilApiCancel } from './merchantListing';

// ------------------------------------
// Watchers
// ------------------------------------
export default function* plansWatcher(): Generator<any, void, unknown> {
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_CUSTOMER_WALLET_ACTION);
  yield fork(
    takeLatestUntilApiCancel,
    ActionConstants.CUSTOMER_WALLET_ACTIVATION_DEACTIVATION_ACTION
  );
  yield fork(takeLatestUntilApiCancel, ActionConstants.CREATE_BULK_WALLET_ACTION);
  yield fork(takeLatestUntilApiCancel, ActionConstants.LOAD_BULK_WALLET_ACTION);
  yield fork(takeLatestUntilApiCancel, ActionConstants.LIST_CREATED_WALLET_ACTION);
  yield fork(takeLatestUntilApiCancel, ActionConstants.LIST_LOAD_WALLET_ACTION);
  yield fork(takeLatestUntilApiCancel, ActionConstants.DOWNLOAD_ERROR_REPORT_ACTION);
  yield fork(
    takeLatestUntilApiCancel,
    ActionConstants.GET_WALLET_TRANSACTION_DETAILS_ACTION
  );
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_WALLET_DETAILS_ACTION);
}
